import { intl } from '../../../../i18n'
import { ColumnFilterButtonGroup } from '../../../components/buttons/ColumnFilterButtonGroup'
import {
  HeaderDivider,
  HeaderGroup,
} from '../../../components/headers/HeaderBar/PageHeader'
import { Toolbar } from '../../../components/toolbars/Toolbar'
import { ToolbarToggleValue } from '../../../components/toolbars/Toolbar/ToolbarToggle'
import { ColumnQuickFilterKey } from '../WorkReportOptions'
import ToolbarFilterButtonGroup, {
  ToolbarFilterGroupProps,
} from '../../../components/buttons/ToolbarFilterButtonGroup'
import { DecimalAndSexagesimalScaleToggleButtonGroup } from '../../../components/inputs/ToggleButtonGroup/DecimalAndSexagesimalScaleToggleGroup'
import { DecimalAndSexagesimalScale } from '../../../../lib/functions/decimalAndSexagesimalScale'

interface OwnProps {
  toolbar: ToolbarToggleValue | undefined
  onChangeColumnFilter: (value: ColumnQuickFilterKey) => void
  decimalScaleUnit: DecimalAndSexagesimalScale
  onChangeDecimalScaleUnit: (v: DecimalAndSexagesimalScale) => void
}

type Props = OwnProps & ToolbarFilterGroupProps

const WorkReportToolbar = (props: Props) => {
  const { decimalScaleUnit, onChangeDecimalScaleUnit } = props
  return (
    <Toolbar>
      {ToolbarToggleValue.DISPLAY === props.toolbar && (
        <>
          <HeaderGroup>
            <ToolbarFilterButtonGroup
              filteredColumns={props.filteredColumns}
              sortedColumns={props.sortedColumns}
              onDeletedFilterColumn={props.onDeletedFilterColumn}
            />
          </HeaderGroup>
          <HeaderDivider />
          <HeaderGroup>
            <ColumnFilterButtonGroup
              options={[
                {
                  label: intl.formatMessage({
                    id: 'bulksheet.toolbar.columnQuickFilter.label.initial',
                  }),
                  value: ColumnQuickFilterKey.INITIAL,
                },
                {
                  label: intl.formatMessage({
                    id: 'bulksheet.toolbar.columnQuickFilter.label.restore',
                  }),
                  value: ColumnQuickFilterKey.RESTORE,
                },
              ]}
              onChange={value =>
                props.onChangeColumnFilter(value as ColumnQuickFilterKey)
              }
            />
            <DecimalAndSexagesimalScaleToggleButtonGroup
              value={decimalScaleUnit}
              onChange={onChangeDecimalScaleUnit}
            />
          </HeaderGroup>
        </>
      )}
    </Toolbar>
  )
}

export default WorkReportToolbar
